export interface InvoiceEditability {
  canEdit: boolean;
  reason: string | null;
  showWarning: boolean;
  warningMessage: string | null;
}

export const checkInvoiceEditability = (invoice: {
  status: string;
  paid_amount?: number | null;
}): InvoiceEditability => {
  const paidAmount = invoice.paid_amount || 0;

  // Check if any payments exist (highest priority)
  if (paidAmount > 0) {
    return {
      canEdit: false,
      reason: 'Cannot edit invoice with recorded payments. To make changes, reverse all payments first.',
      showWarning: false,
      warningMessage: null
    };
  }

  // Check status-based restrictions
  switch (invoice.status) {
    case 'paid':
      return {
        canEdit: false,
        reason: 'Cannot edit a paid invoice.',
        showWarning: false,
        warningMessage: null
      };
    case 'partially_paid':
      return {
        canEdit: false,
        reason: 'Cannot edit invoice with partial payments.',
        showWarning: false,
        warningMessage: null
      };
    case 'cancelled':
      return {
        canEdit: false,
        reason: 'Cannot edit a cancelled invoice.',
        showWarning: false,
        warningMessage: null
      };
    case 'sent':
    case 'overdue':
      return {
        canEdit: true,
        reason: null,
        showWarning: true,
        warningMessage: 'This invoice has been sent to the customer. Editing it may cause discrepancies with the copy they received.'
      };
    case 'draft':
    default:
      return {
        canEdit: true,
        reason: null,
        showWarning: false,
        warningMessage: null
      };
  }
};
